module.exports = __webpack_public_path__ + "img/key.9cdd720f.svg";